import { ArrowUpRightFromSquareOutlined } from '@vindr/icons';
import cx from '@vindr/utils/helpers/cx';
import { AnchorHTMLAttributes, FC } from 'react';
import './OpenNewTab.css';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  title: string;
  titleClassName?: string;
  disabled?: boolean;
}

const OpenNewTab: FC<Props> = ({ className, disabled, onClick, title, titleClassName, ...props }) => {
  return (
    <a
      target="_blank"
      title={title}
      className={cx(
        'link flex h-[fit-content] cursor-pointer items-center justify-end pb-[6px] leading-5 text-primary-light',
        className
      )}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
        }
        if (onClick) {
          onClick(e);
        }
      }}
      {...props}
    >
      {/* hidden min-[340px]:block */}
      <span className={cx('mr-2', titleClassName)}>{title}</span>
      <ArrowUpRightFromSquareOutlined className="h-[fit-content] fill-[#39c2d7] pt-[3px] text-primary-light min-[340px]:pt-0" />
    </a>
  );
};

export default OpenNewTab;
